import { Button } from '@fabric-app/ui/components/Button';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { styled } from 'styled-components';

export const AuthButton = styled(Button)`
  height: 50px;
  background: ${cssVar['color-bg-primary-reverse']};
  color: ${cssVar['color-text-primary-reverse']};
  font-size: 1rem !important;
  border-radius: 13px;
  font-weight: 600;
  width: 100%;
  border: none !important;
  transition: none;
`;
